import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import MigrationEmbed from './migration-embed';

@NgModule({
    declarations: [
        MigrationEmbed,
    ],
    imports: [
        BrowserModule,
        FormsModule,
        TranslateModule,
        RouterModule
    ],
    providers: [

    ],
    exports: [
        MigrationEmbed
    ]
})

export class MigrationModule {
    constructor() { }
}



// WEBPACK FOOTER //
// ./src/app/components/migration/migration.module.ts